import { FormControl, UntypedFormGroup } from '@angular/forms';
import { PersonalDetailsForm } from '../../models/personal-details/personal-details-form.interface';

export const mockPersonalDetailsForm: PersonalDetailsForm = {
  address: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
    isOverrideAddress: new FormControl(),
  }),
  emailAddress: new FormControl(null),
  firstName: new FormControl(null),
  lastName: new FormControl(null),
  telephoneNumber: new FormControl(null),
  titleId: new FormControl(null),
};
